import React from 'react';
import { Palette } from 'lucide-react';
import ColorPicker from '../../pages/Customiz3r/components/ToolSelectorRight/components/ColorPicker.jsx';

// Panel de personalización de colores de los visores 3D: lista las piezas
// del modelo cargado (`parts`, ver useModel3DViewer.js) y permite recolorear
// la seleccionada en vivo, sin recargar ni persistir el GLB.
const ColorPanel = ({ parts, colors, selectedPartKey, onSelectPart, onColorChange, onClose }) => {
    const selectedPart = parts.find((part) => part.key === selectedPartKey) || parts[0] || null;

    return (
        <div className="absolute bottom-20 left-4 right-4 lg:left-auto lg:right-4 lg:w-72 z-40">
            <div className="bg-base-100/95 backdrop-blur-lg border border-base-300 rounded-2xl shadow-2xl p-4">
                <div className="flex items-center justify-between mb-3">
                    <div className="flex items-center gap-2">
                        <Palette className="w-4 h-4 text-primary" />
                        <p className="text-xs font-semibold text-base-content/70 uppercase tracking-wide">
                            Personalizar colores
                        </p>
                    </div>
                    <button
                        onClick={onClose}
                        className="btn btn-xs btn-ghost btn-circle"
                        aria-label="Cerrar"
                    >
                        ✕
                    </button>
                </div>

                {parts.length === 0 ? (
                    <p className="text-xs text-base-content/50">
                        No hay piezas disponibles para colorear.
                    </p>
                ) : (
                    <div className="space-y-3">
                        <div className="flex flex-wrap gap-2">
                            {parts.map((part) => (
                                <button
                                    key={part.key}
                                    onClick={() => onSelectPart(part.key)}
                                    className={`h-7 w-7 shrink-0 rounded-md border shadow-inner transition-all ${
                                        (selectedPart?.key === part.key)
                                            ? 'border-primary ring-2 ring-primary'
                                            : 'border-base-300'
                                    }`}
                                    style={{ backgroundColor: colors[part.key] || part.colorHex || '#888888' }}
                                    title={part.name}
                                    aria-label={`Seleccionar pieza ${part.name}`}
                                />
                            ))}
                        </div>

                        {selectedPart && (
                            <ColorPicker
                                value={colors[selectedPart.key] || selectedPart.colorHex}
                                onChange={(color) => onColorChange(selectedPart, color)}
                                allowVaciado={false}
                            />
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

export default ColorPanel;
